import React from 'react';
import {
    Box,
    FormControl,
    MenuItem,
    Select,
    Typography,
    Tooltip
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { colors } from 'features/userData/style';
import * as geoConfig from 'config/geocoder/config';

// 섹션 컴포넌트
export const Section = ({ children, sx = {} }) => (
    <Box
        sx={{
            mb: 3,
            ...sx
        }}
    >
        {children}
    </Box>
);

// 섹션 제목 컴포넌트
export const SectionTitle = ({ children, sx = {} }) => (
    <Typography 
        variant="subtitle2" 
        sx={{ 
            mt: 1,
            mb: 2, 
            pl: 1.3,
            fontWeight: 700,
            fontSize: 16,
            borderLeft: `4px solid ${colors.primaryBlue}`,
            display: 'flex',
            alignItems: 'center',
            ...sx
        }}
    >
        {children}
    </Typography>
);

// 섹션 내용 컴포넌트
export const SectionBody = ({ children, sx = {} }) => (
    <Box sx={{ pl: 1, pb: 2, ...sx }}>{children}</Box>
);

// 입력 컴포넌트
export const InputForm = ({ label, selectVal, options, menuItemKey, onChange, sx = {}, tooltip, disabled }) => (
    <FormControl
        size="small"
        disabled={disabled || false}
        sx={{
            mb: 3,
            width: sx.minWidth || '100%',
            '& .MuiOutlinedInput-root': { height: geoConfig.CONTROL_HEIGHT, width: '100%' },
            '& .MuiSelect-select': {
                display: 'flex',
                alignItems: 'center',
                py: 0,
            },
            ...sx,
        }}
    >
        <Typography variant="body2" sx={geoConfig.inputLabelSx}>
            {label}
            {tooltip?.length > 0 ? (
                <Tooltip 
                    title={tooltip}
                    placement="right"
                    arrow
                >
                    <HelpOutlineIcon 
                        // fontSize="small" 
                        sx={{
                            fontSize: 15,
                            color: 'primary.main',
                            cursor: 'pointer',
                            ml: 1,
                            mb: 0.1
                        }} 
                        />
                </Tooltip>
            ) : (
                <></>
            )}
        </Typography>
        <Select
            size="small"
            value={selectVal?.value ?? ''}
            onChange={(e) => onChange(e.target.value)}
            renderValue={(value) => (
            <Typography
                variant="body1"
                noWrap 
            >
                {selectVal?.value || value} 
            </Typography>
        )}
        >
            {options?.map((opt, index) => {
                let uniqueKey;
                if (typeof menuItemKey === 'function') {
                    // menuItemKey가 함수인 경우
                    uniqueKey = menuItemKey(opt, index); 
                } else {
                    // menuItemKey가 문자열(속성 키)인 경우
                    uniqueKey = opt[menuItemKey];
                }

                return <MenuItem key={uniqueKey} value={opt.value}>{opt.value}</MenuItem>
            })}
        </Select>
    </FormControl>
);